import { createSelector } from 'reselect';
import { get } from 'lodash';
import { getFormValues } from 'redux-form';
import { FORM_NAME } from '../Form';

const selectProject = state => state.modals.Order.project;
const selectProjects = state => state.core.projects;
const selectFormValues = state => getFormValues(FORM_NAME)(state);

export default createSelector(
  [selectProject, selectProjects, selectFormValues],
  (project, projects, formValues) => {
    // First try from loaded project data
    const clientIdFromProject = get(project, 'client_site.client.id', null);
    if (clientIdFromProject) {
      return clientIdFromProject;
    }

    // Fallback: look up from core.projects using form's project_id
    if (formValues && formValues.project_id && projects.length > 0) {
      const coreProject = projects.find(p => p.id === formValues.project_id);
      return get(coreProject, 'client_site.client.id', null);
    }

    return null;
  }
)
